export const TWILIO_STATUS_URL = 'https://status.twilio.com/api/v2/summary.json'

export const POLL_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes

/** Component IDs monitored (France + Belgium / European coverage) */
export const WATCHED_COMPONENT_IDS = [
  { id: 'bnzggd37p61w', label: 'Voix (France / Belgique)' },
  { id: 'llgdln3dcs6p', label: 'SMS (France / Belgique)' },
  { id: 'hzh0mwy93r9z', label: 'Infrastructure vocale (EU)' },
]

export const STATUS_CONFIG = {
  operational: { color: '#28c76f', label: 'Opérationnel' },
  degraded_performance: { color: '#ff9f43', label: 'Dégradé' },
  partial_outage: { color: '#ea5455', label: 'Panne partielle' },
  major_outage: { color: '#ea5455', label: 'Panne majeure' },
  under_maintenance: { color: '#00cfe8', label: 'Maintenance' },
}

/** Ordered from most severe to least, used to compute the overall worst status */
export const STATUS_PRIORITY = [
  'major_outage',
  'partial_outage',
  'degraded_performance',
  'under_maintenance',
  'operational',
]

export function statusColor(status) {
  return STATUS_CONFIG[status]?.color ?? '#b9b9c3'
}

export function statusLabel(status) {
  return STATUS_CONFIG[status]?.label ?? '-'
}

export function badgeVariant(status) {
  const map = {
    operational: 'light-success',
    degraded_performance: 'light-warning',
    partial_outage: 'light-danger',
    major_outage: 'light-danger',
    under_maintenance: 'light-info',
  }
  return map[status] ?? 'light-secondary'
}

export function impactColor(impact) {
  const map = {
    critical: '#ea5455',
    major: '#ea5455',
    minor: '#ff9f43',
    maintenance: '#00cfe8',
  }
  return map[impact] ?? '#ff9f43'
}
